export const WORKFLOW_UPDATE_STAGE = 'review-workflows.updateEntryStage';

export default {
  WORKFLOW_UPDATE_STAGE,
};
